

import { Control } from 'react-hook-form';
import { ProfileFormValues } from '../ProfileFormSchema';
import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';

type HomeGymFieldProps = {
  control: Control<ProfileFormValues>;
};

export function HomeGymField({ control }: HomeGymFieldProps) {
  return (
    <FormField
      control={control}
      name="home_gym"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Home Gym</FormLabel>
          <FormControl>
            <Input placeholder="Enter your home gym name" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
